import $ from 'jquery';
import util from 'util/Util';
import constants from 'Constants';
import BasePropertyView from 'BasePropertyView.js';
import formatTemplate from 'properties/main/date_value.ejs';
import dateUtil from 'shared/DateUtil.js';

import mobileSyncService from "../../../service/mobile/MobileSyncService";

class MainDateValueView extends BasePropertyView {
    initialize(opts) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.events = {
            'change input[type=radio]': 'handleChangeDateValueType',
            'change #dateValueSpecific': 'handleChangeSpecificDate',
            'change #dateFormat, #yearsFrom, #yearsTo': 'handleChangeAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };
        this.id = opts.el;
        this.config = opts.config || {};

        if (!this.model.get('specific')) {
            this.model.set('specific', '', { silent: true });
        }

        if (!this.model.get('specificDisplay')) {
            this.model.set('specificDisplay', '', { silent: true });
        }

        if (!this.model.get('format')) {
            this.model.set('format', 'MM/DD/YYYY', { silent: true });
        }

        if (!this.model.get('minYear')) {
            this.model.set('minYear', '1900', { silent: true });
        }

        if (!this.model.get('maxYear')) {
            this.model.set('maxYear', '2100', { silent: true });
        }

        dateUtil.updateValueType(this.model);

        // Recalculate date, silently        
        this.recalculateDate(true);

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    handleChangeAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set(propName, propVal);

        this.syncDesktopMobile({key: propName, val: propVal });

        this.recalculateDate(false);
    }

    handleChangeSpecificDate(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        const newSpecificDisplay = dateUtil.getFormattedDate(propVal, constants.PROP_DEFAULT_DATE_FORMAT);
        const newSpecific = dateUtil.convertDateToISOString(propVal);
        if(!newSpecificDisplay){
           ev.currentTarget.value = this.model.get('specificDisplay');
           return;
        }

        this.model.set('specificDisplay', newSpecificDisplay);
        this.syncDesktopMobile({key: 'specificDisplay', val: newSpecificDisplay });

        this.model.set('specific', newSpecific);
        this.syncDesktopMobile({key: 'specific', val: newSpecific });
    }


    handleChangeDateValueType(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set('showEmpty', 'false', { silent: true });
        this.syncDesktopMobile({key: 'showEmpty', val: 'false' });

        this.model.set('showNow', 'false', { silent: true });
        this.syncDesktopMobile({key: 'showNow', val: 'false' });

        this.model.set('specificDisplay', '', { silent: true });
        this.syncDesktopMobile({key: 'specificDisplay', val: '' });
        switch (propVal) {
            case "Empty":
                this.model.set('showEmpty', 'true', { silent: true });
                this.syncDesktopMobile({key: 'showEmpty', val: 'true' });
                break;
            case "Now":
                this.model.set('showNow', 'true', { silent: true });
                this.syncDesktopMobile({key: 'showNow', val: 'true' });
                break;
            case "Specific":
                break;
        }

        this.model.set(propName, propVal, { silent: true });
        this.syncDesktopMobile({key: propName, val: propVal });

        this.recalculateDate(false);
    }

    recalculateDate(silent) {
        let propVal = this.model.get('dateValueType');
        dateUtil.updateModel(this.model);

        if (!silent) {
            this.model.trigger('change');
        }
    }

    syncDesktopMobile(data) {
        mobileSyncService.synchronizeMobileForm(this.model, this.model.get('factoryKey'), data);
    }

    render() {

            let format = '';
            if (this.model.get('dateValueType') !== 'Empty') {
                if (!this.model.get('specificDisplay')) {
                    this.model.set('specificDisplay', dateUtil.getFormattedDate(this.model.get("specific"), constants.PROP_DEFAULT_DATE_FORMAT),{silent:true});
                    format = constants.PROP_DEFAULT_DATE_FORMAT;

                }
                else {
                    this.model.set('specificDisplay', dateUtil.getFormattedDate(this.model.get("specific"), this.model.get('format')), {silent:true});
                    format = this.model.get('format');
                }
            }

            this.syncDesktopMobile({key: 'specificDisplay', val: dateUtil.getFormattedDate(this.model.get("specific"), format)});


        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $(":radio[value='" + this.model.get('dateValueType') + "']").attr('checked', true);

        if (this.model.get('format')) {
            $('#dateFormat').find("option[value='" + this.model.get('format') + "']").attr('selected', true);
        }

        this._injectDatePicker();

        // Disable or enable date picker        
        if (this.model.get('dateValueType') !== 'Specific') {
            $("#dateValueSpecific").datepicker('disable');
            $('#dateValueSpecific ~ img').css( 'opacity', constants.CSS_CALENDAR_DISABLE);
        }
        else {
            $("#dateValueSpecific").datepicker('enable');
            $('#dateValueSpecific ~ img').css('opacity',constants.CSS_CALENDAR_ENABLE);
        }

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }

        this.delegateEvents();
        return this;
    }

    _injectDatePicker() {
        const $dp = $('#dateValueSpecific');
        let self=this;

        let modelDate = dateUtil.convertISOStringToDate(this.model.get('specific'));
        if (!modelDate) {
            modelDate = new Date();
        }

        $dp.datepicker({
            showOn: "button",
            buttonImageOnly: true,
            buttonImage: require('common/icons/calendar.png'),
            'disabled': true,
            changeYear: true,
            changeMonth: true,
            gotoCurrent: true,
            defaultDate: modelDate,
            yearRange: this.model.get('minYear')+':' +this.model.get('maxYear'),
            beforeShow: function( opts ){
                setTimeout(function(){
                    $('.ui-datepicker').css('z-index', constants.Z_INDEX_CALENDAR);
                }, 0);
            },
            onSelect: (opts) => {
                self.model.set('specific', dateUtil.convertDateToISOString(new Date(opts)),{silent:true});
                self.syncDesktopMobile({key: 'specific', val:  dateUtil.convertDateToISOString(new Date(opts)) });

                self.model.set('specificDisplay', dateUtil.getFormattedDate(opts, constants.PROP_DEFAULT_DATE_FORMAT),{silent:true});
                self.syncDesktopMobile({key: 'specificDisplay', val: dateUtil.getFormattedDate(opts, constants.PROP_DEFAULT_DATE_FORMAT) });
                self.model.trigger('change');
            }
        });
    }
}

export default MainDateValueView;
